import React from 'react';
import ReactDOM from 'react-dom/client';

// Estilos
import './index.css';
import './style/botones.css';
import './style/inputs.css';

import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './utils/pdfMakeConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);